(function() {
	'use strict';

	angular.module('app.dashboard')
	.config(shortagePoActionsConfig);


	function shortagePoActionsConfig (dashboardProvider) {
		// register widget
		dashboardProvider.widget(
			'shortagePoActions', {
				name: 'Shortage PO Actions by Depth of Delay',
				description: 'Shows Shortage PO Actions each historical week grouped by the Depth of Delay.',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/shortage-po-actions-by-depth-of-delay.png',
				slideshowView: true,
				categories: ['All', 'Shortages'],
				config: {},
				isActive: true,
				controller: 'shortagePoActionsCtrl',
				templateUrl: '/application/f/dashboard/widgets/shortage-po-actions.html',
				drillDownUrl: '',
				reload: true,
				isDrillDown: true
			}
		);
	}
})();
